import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Interest } from 'src/app/models/skills/interest.model';
import { Skill } from 'src/app/models/skills/skill.model';

@Component({
    selector: 'app-widget-connect-filters',
    templateUrl: './widget-connect-filters.component.html',
    styleUrls: ['./widget-connect-filters.component.scss'],
})
export class WidgetConnectFiltersComponent {
    @Input() radioLabelMine: string = '';
    @Input() radioLabelSpecific: string = '';
    @Input() dropdownPlaceholder: string = '';
    @Input() dropdownOptions: Skill[] | Interest[] = [];

    @Input() radioButtonGroupName: string = '';

    @Output() formChange = new EventEmitter<any>();

    selectedOption: string = 'mySkillsOrInterests';
    selectedItem: any = null;

    emitChanges() {
        this.formChange.emit({
            option: this.selectedOption,
            item: this.selectedItem,
        });
    }
    public reset() {
        this.selectedOption = 'mySkillsOrInterests';
        this.selectedItem = null;
        this.emitChanges();
    }
}
